import { ICauHinhXeBusSaveRequest } from "../../../models/request/bus/cauHinhXeBusSaveRequest";
import { dm_cauhinhxebus } from "../../../models/response/bus/dm_cauhinhxebus";
import {
	eCauHinhXeBusActionTypeIds,
	ICauHinhXeBusChangeSelectedIds,
	ICauHinhXeBusCloseConfirm,
	ICauHinhXeBusCloseDetail,
	ICauHinhXeBusDeleteErr,
	ICauHinhXeBusDeleteStart,
	ICauHinhXeBusDeleteSuccess,
	ICauHinhXeBusLoadErr,
	ICauHinhXeBusLoadStart,
	ICauHinhXeBusLoadSuccess,
	ICauHinhXeBusSaveErr,
	ICauHinhXeBusSaveStart,
	ICauHinhXeBusSaveSuccess,
	ICauHinhXeBusShowConfirm,
	ICauHinhXeBusShowDetail
} from "../../action-types/bus/ICauHinhXeBusActionTypes";

export const cauHinhXeBusActions = {
	loadCauHinhXeBusStart: (dm_coso_id: number): ICauHinhXeBusLoadStart => {
		return {
			type: eCauHinhXeBusActionTypeIds.LOAD_START,
			payload: dm_coso_id
		}
	},
	loadCauHinhXeBusSuccess: (data: dm_cauhinhxebus[]): ICauHinhXeBusLoadSuccess => {
		return {
			type: eCauHinhXeBusActionTypeIds.LOAD_SUCCESS,
			payload: data
		}
	},
	loadCauHinhXeBusError: (message: string): ICauHinhXeBusLoadErr => {
		return {
			type: eCauHinhXeBusActionTypeIds.LOAD_ERROR,
			payload: message
		}
	},
	showCauHinhXeBusDetail: (data?: dm_cauhinhxebus): ICauHinhXeBusShowDetail => {
		return {
			type: eCauHinhXeBusActionTypeIds.SHOW_DETAIL,
			payload: data
		}
	},
	closeCauHinhXeBusDetail: (): ICauHinhXeBusCloseDetail => {
		return {
			type: eCauHinhXeBusActionTypeIds.CLOSE_DETAIL
		}
	},
	showCauHinhXeBusConfirm: (): ICauHinhXeBusShowConfirm => {
		return {
			type: eCauHinhXeBusActionTypeIds.SHOW_CONFIRM
		}
	},
	closeCauHinhXeBusConfirm: (): ICauHinhXeBusCloseConfirm => {
		return {
			type: eCauHinhXeBusActionTypeIds.CLOSE_CONFIRM
		}
	},
	changeCauHinhXeBusSelectedIds: (ids: number[]): ICauHinhXeBusChangeSelectedIds => {
		return {
			type: eCauHinhXeBusActionTypeIds.CHANGE_SELECTED_IDS,
			payload: ids
		}
	},
	deleteCauHinhXeBusStart: (id: number): ICauHinhXeBusDeleteStart => {
		return {
			type: eCauHinhXeBusActionTypeIds.DELETE_START,
			payload: id
		}
	},
	deleteCauHinhXeBusSuccess: (): ICauHinhXeBusDeleteSuccess => {
		return {
			type: eCauHinhXeBusActionTypeIds.DELETE_SUCCESS
		}
	},
	deleteCauHinhXeBusErr: (message: string): ICauHinhXeBusDeleteErr => {
		return {
			type: eCauHinhXeBusActionTypeIds.DELETE_ERROR,
			payload: message
		}
	},
	saveCauHinhXeBusStart: (data: ICauHinhXeBusSaveRequest): ICauHinhXeBusSaveStart => {
		return {
			type: eCauHinhXeBusActionTypeIds.SAVE_START,
			payload: data
		}
	},
	saveCauHinhXeBusSuccess: (): ICauHinhXeBusSaveSuccess => {
		return {
			type: eCauHinhXeBusActionTypeIds.SAVE_SUCCESS
		}
	},
	saveCauHinhXeBusError: (message: string): ICauHinhXeBusSaveErr => {
		return {
			type: eCauHinhXeBusActionTypeIds.SAVE_ERR,
			payload: message
		}
	}
}
